import { ChoiceGroup } from "@/components/forms/ChoiceGroup";

type Props = {
  id: string;
  label: string;
  min: number;
  max: number;
  labels?: Record<string, string>;
  value: unknown;
  onChange: (v: number) => void;
  error?: string;
  note?: string;
};

export function FieldScale({
  id,
  label,
  min,
  max,
  labels,
  value,
  onChange,
  error,
  note,
}: Props) {
  const n = typeof value === "number" ? value : undefined;
  const nums: number[] = [];
  for (let i = min; i <= max; i++) nums.push(i);

  // 44px number chips that wrap to a second row on a phone; nothing selected until tapped.
  return (
    <div className="intake-scale mb-6">
      <ChoiceGroup
        id={id}
        layout="numbers"
        legend={label}
        hint={note}
        options={nums.map((x) => ({ value: String(x), label: String(x) }))}
        value={n != null ? String(n) : null}
        onChange={(v) => {
          if (v != null) onChange(Number(v));
        }}
        error={error}
      />
      {n != null && labels?.[String(n)] && (
        <p className="mt-2 text-[15px] text-[#6F7375]">{labels[String(n)]}</p>
      )}
    </div>
  );
}
